import type { ICountryDefinition } from "@/countries/country-common";

import { EAddressProvider } from "@/domains/address/providers/address-provider.types";
import { ECountry, ECountryCode, ELanguageCode } from "@/domains/country/country.types.ts";

export const BELGIUM_DATABASE_COUNTRY_ID = 3;

export const BelgiumCountryDefinition = {
  addressProvider: EAddressProvider.GOOGLE,
  countryCode: ECountryCode.BELGIUM,
  languageCode: ELanguageCode.FRENCH,
  country: ECountry.BELGIUM,
  phoneAllowed: true,
  addressAllowed: false,
  phone: {
    mask: "+32 99999999?9",
    placeholder: "+32 4 99 99 99 99",
    prefix: "+32",
  },
  databaseCountryId: BELGIUM_DATABASE_COUNTRY_ID,
} as const satisfies ICountryDefinition;
